import { render } from "./tab-overview.vue?vue&type=template&id=10937e69"
import script from "./tab-overview.vue?vue&type=script&lang=js"
export * from "./tab-overview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__